import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RegisterFacade {
    public stepActive: BehaviorSubject<number> = new BehaviorSubject<number>(1);
}